export enum LogicalOperator {
    And,
    Or,
    AndNot,
}
